module.exports = __webpack_public_path__ + "img/re.17909e37.svg";